/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:991.98px){.welcome-banner[_ngcontent-%COMP%]{padding-left:25px;padding-right:15px}}.welcome-banner[_ngcontent-%COMP%]{padding-left:15px;margin-bottom:0}"];
export { styles as styles };
